import { render } from "./Roles.vue?vue&type=template&id=28a7467e&ts=true"
import script from "./Roles.vue?vue&type=script&lang=ts"
export * from "./Roles.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__